// extracted by mini-css-extract-plugin
export default {"formContainer":"ConsultationForm_formContainer__+FfOn","addDescriptionContainer":"ConsultationForm_addDescriptionContainer__eUT0k"};